import { ReactNode } from 'react'

import { BaseOptionType } from 'antd/es/select'
import { useField, useFormikContext } from 'formik'

import Label from '../components/Label'
import Select from '../components/Select'
import FieldProps from './FieldProps'
import Error from './FormItemError'

type SelectProps = FieldProps & {
  children?: ReactNode
  defaultValue?: string[]
  mode?: 'multiple' | 'tags'
  size?: 'large' | 'small' | 'middle'
  filterOption?: boolean | ((inputValue: string, option: BaseOptionType) => boolean)
}

const FormikSelectField = (props: SelectProps) => {
  const [field, meta] = useField(props.name)
  const context = useFormikContext()
  const showError = meta.touched && meta.error
  const error = showError ? <Error>{meta.error}</Error> : <Error></Error>

  const onChange = (value: any, key: any) => {
    context.setFieldValue(props.name, key.key)
    props.onChange && props.onChange(key.key)
  }

  return (
    <>
      <div className="formik-field">
        <div className="input-wrapper">
          {props.label && (
            <Label htmlFor={props.id || props.name} className="formik-field__input-label no-select hand-on-hover">
              {props.label}
            </Label>
          )}
          <Select
            {...props}
            className={`formik-input__with-suffix formik_input input__no-autofill-color ${props.className}`}
            id={props.id || props.name}
            showSearch={true}
            onChange={onChange}
          >
            {props.children}
          </Select>
        </div>
      </div>
      {error}
    </>
  )
}
export { FormikSelectField as SelectField }
export default FormikSelectField
